import { useApp } from '../../context/AppContext';
import { PageShell } from '../shared/PageShell';
import { FullReportView } from './FullReport';
import { ArrowLeft, Upload } from 'lucide-react';

export function ReportPage() {
  const { state, dispatch } = useApp();

  // No report yet — prompt upload
  if (!state.fullReport) {
    return (
      <PageShell>
        <div className="flex flex-col items-center justify-center min-h-screen px-6">
          <div className="w-16 h-16 rounded-2xl bg-bg-card border border-bg-tertiary flex items-center justify-center mb-4">
            <Upload size={28} className="text-text-muted" />
          </div>
          <h2 className="font-display text-xl font-bold mb-2 text-text-primary">No Report Yet</h2>
          <p className="text-text-muted text-sm text-center max-w-xs mb-6">
            Upload your lab results to get a full narrative analysis of your biomarkers.
          </p>
          <button
            onClick={() => dispatch({ type: 'SET_SCREEN', payload: 'landing' })}
            className="px-6 py-2.5 rounded-xl bg-accent text-white font-semibold text-sm hover:brightness-110 transition-all"
          >
            Upload Labs
          </button>
        </div>
      </PageShell>
    );
  }

  return (
    <PageShell>
      <div className="min-h-screen bg-bg-deep">
        {/* Nav bar */}
        <div className="flex items-center gap-3 px-4 py-3 border-b border-bg-tertiary bg-bg-card">
          <button
            onClick={() => dispatch({ type: 'SET_SCREEN', payload: 'chat' })}
            className="text-text-muted hover:text-text-primary transition-colors"
          >
            <ArrowLeft size={20} />
          </button>
          <h1 className="font-display text-base font-bold text-text-primary">Lab Analysis</h1>
        </div>

        {/* Report content */}
        <FullReportView
          report={state.fullReport}
          biomarkers={state.labReport?.biomarkers}
        />
      </div>
    </PageShell>
  );
}
